// extracted by mini-css-extract-plugin
export default {"container":"Surplus_container__mgPfk","badge":"Surplus_badge__G6fP5","list":"Surplus_list__lN3nC","user":"Surplus_user__I8hIi"};